// First, so a failure in anything below is still seen (qa-runs 1227).
import './diagnosticsBoot';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { App } from './App';
import { Table } from './pages/Table';
import { SharedLink } from './pages/SharedLink';
import { registerServiceWorker } from './pwa';
import { DiagnosticsBoundary } from './DiagnosticsBoundary';
import './diagnostics';
// The tracker's data-before-send hook, installed before the tracker's first page view (issue 1601).
import './analytics';
import './index.css';

// The installed app's worker (issue 1182): install and push only; it caches nothing.
void registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <DiagnosticsBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/t/:campaignId" element={<Table />} />
          <Route path="/library/shared/:token" element={<SharedLink />} />
        </Routes>
      </BrowserRouter>
    </DiagnosticsBoundary>
  </React.StrictMode>,
);
